import {
  Manager,
  Metal,
  Scope,
  SquadBuilderPlayerType,
} from "../../../redux/squadBuilder/squadBuilderUtils";
import axios from "../../apiFc24";

export type FromBackendSquad = {
  players: SquadBuilderPlayerType[];
  manager: Manager;
  chemistry: number;
  metaRating: number;
};

export const buildSquads = ({
  playersFrom,
  players,
  budget,
  benchBudget,
  manager,
  country,
  league,
  club,
  pastAndPresentClub,
  version,
  metal,
  playerFilters,
  formationId,
  excludeIconsHeroes,
  minRating,
  maxRating,
  includeLoanPlayers,
}: {
  playersFrom: Scope;
  players: { resourceId?: number; playerRoleId: number; position: string }[];
  budget: number;
  benchBudget: number;
  manager: Manager;
  country: number[];
  league: number[];
  club: number[];
  pastAndPresentClub: number[];
  version: number[];
  metal: Metal[];
  playerFilters: undefined[] | any[];
  formationId: string;
  excludeIconsHeroes?: boolean;
  minRating?: number;
  maxRating?: number;
  includeLoanPlayers?: boolean;
}) => {
  return axios.post<FromBackendSquad[]>("/squad-builder?v=2", {
    playersFrom,
    players,
    formationId,
    budget,
    benchBudget,
    manager,
    metal,
    country,
    league,
    club,
    pastAndPresentClub,
    version,
    playerFilters,
    excludeIconsHeroes,
    minRating,
    maxRating,
    includeLoanPlayers,
  });
};
